// Iššūkiai — misijos su progresu. Skiriasi nuo ženkliukų: tai „kiti tikslai",
// kurie, kai įveikiami, rodomi su švente iki KITO ekrano atidarymo, tada dingsta.
//
// „Įveikta" žymėjimas: kai atidarai ekraną, įveiktus, kurių dar nematei, parodom
// pažymėtus; uždarant (ar kitą kartą atidarant) juos pažymim „matyta" ir jie
// neberodomi aktyviame sąraše.

const MATYTI_RAKTAS = 'issukiai_matyti' // įveiktų ir jau matytų id sąrašas

// Kategorijos — pagal jas grupuojam „Ką gali pradėti". Tvarka = rodymo tvarka.
export const KATEGORIJU_TVARKA = ['Kelionės', 'Gamta', 'Istorija', 'Prisiminimai', 'Atstumas', 'Regionai']

export const ISSUKIAI = [
  { id: 'pirmas_prisiminimas', kategorija: 'Prisiminimai', pavadinimas: 'Pirmas prisiminimas', aprasymas: 'Užfiksuok pirmą nuotrauką kelionėje', ikona: 'photo', tikslas: 1, dabartinis: s => s.nuotraukos },
  { id: 'penki_prisiminimai', kategorija: 'Prisiminimai', pavadinimas: 'Kelionių albumas', aprasymas: 'Surink 5 prisiminimus', ikona: 'photo', tikslas: 5, dabartinis: s => s.nuotraukos },
  { id: 'deste_vietu', kategorija: 'Kelionės', pavadinimas: 'Įsibėgėjai', aprasymas: 'Aplankyk 10 vietų', ikona: 'map-pin', tikslas: 10, dabartinis: s => s.vietos },
  { id: 'trys_gamtos', kategorija: 'Gamta', pavadinimas: 'Į mišką', aprasymas: 'Aplankyk 3 gamtos vietas', ikona: 'leaf', tikslas: 3, dabartinis: s => s.pagalKategorija.gamta.aplankyta },
  { id: 'trys_pilys', kategorija: 'Istorija', pavadinimas: 'Pilių keliais', aprasymas: 'Aplankyk 3 istorijos vietas', ikona: 'tower', tikslas: 3, dabartinis: s => s.pagalKategorija.istorija.aplankyta },
  { id: 'toli_50', kategorija: 'Atstumas', pavadinimas: 'Toli nuo namų', aprasymas: 'Nukeliauk 50+ km į vieną vietą', ikona: 'route', tikslas: 50, dabartinis: s => s.tolimiausia },
  { id: 'trys_regionai', kategorija: 'Regionai', pavadinimas: 'Po Lietuvą', aprasymas: 'Aplankyk 3 skirtingus regionus', ikona: 'map-2', tikslas: 3, dabartinis: s => s.regionai },
]

export function getIssukiai(statai) {
  return ISSUKIAI.map(i => {
    const esamas = Math.max(0, i.dabartinis(statai) || 0)
    return {
      id: i.id, kategorija: i.kategorija, pavadinimas: i.pavadinimas, aprasymas: i.aprasymas, ikona: i.ikona,
      tikslas: i.tikslas, esamas: Math.min(esamas, i.tikslas), uzdirbtas: esamas >= i.tikslas,
    }
  })
}

export function getMatyti() {
  try {
    const r = localStorage.getItem(MATYTI_RAKTAS)
    return r ? JSON.parse(r) : []
  } catch {
    return []
  }
}

// Pažymi visus perduotus id kaip „matytus" (įveiktus ir jau parodytus).
export function pazymetiMatyta(ids) {
  try {
    const dabar = new Set(getMatyti())
    ids.forEach(id => dabar.add(id))
    localStorage.setItem(MATYTI_RAKTAS, JSON.stringify([...dabar]))
  } catch {}
}
